import SimpleVideoPlayer from '@/src/shared/components/SimpleVideoPlayer';

export const Video = () => {
  return (
    <SimpleVideoPlayer
      src="/videos/roomvu-to-vusocial.mp4"
      autoPlay
      loop
      muted
      playsInline
      controls={false}
    />
  );
};
